import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as glAccounts from '../../gl-accounts'

export const RESOURCE = {
  payload: {
    description: 'A financial account in the institution’s general ledger.',
    dimension: glAccounts.RESOURCE.payload,
    level: 0,
    name: 'Account',
    partialId: PartialId.Standard.create('acct'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
